// Entry point for the build script in your package.json
import { Turbo } from "@hotwired/turbo-rails"
import "./controllers"

Turbo.StreamActions.fade_remove = function() {
  const el = document.getElementById(this.target)
  if (!el) return
  el.style.transition = "opacity 0.5s ease-out, transform 0.5s ease-out"
  el.style.opacity = "0"
  el.style.transform = "scale(0.97)"
  setTimeout(() => el.remove(), 500)
}
import Highcharts from "highcharts"
import Chartkick from "chartkick"
Chartkick.use(Highcharts)
Chartkick.options = { messages: { empty: "Sem dados para exibir" } }

Highcharts.setOptions({
  lang: {
    months: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
             "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
    shortMonths: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun",
                  "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
    weekdays: ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"],
    loading: "Carregando...",
    noData: "Sem dados para exibir",
    resetZoom: "Resetar zoom",
    resetZoomTitle: "Resetar zoom 1:1",
    thousandsSep: ".",
    decimalPoint: ",",
    printChart: "Imprimir gráfico",
    downloadPNG: "Baixar imagem PNG",
    downloadJPEG: "Baixar imagem JPEG",
    downloadPDF: "Baixar documento PDF",
    downloadSVG: "Baixar imagem SVG",
    contextButtonTitle: "Menu do gráfico"
  }
})

window.CKEDITOR_GLOBAL_LICENSE_KEY = "GPL"

import intlTelInput from "intl-tel-input"
window.intlTelInput = intlTelInput
